import type { GraphQLResult } from 'aws-amplify/api'
import { useQuery } from '@tanstack/react-query'
import { OrganizationMember } from '@skop-app/lib-domain/types'

import { getAmplifyClient } from '@/services/amplifyClient'
import { listUserInvitsQuery } from '@/services/graphql/notification'
import { notificationAdapter } from '@/services/adapters'

const client = getAmplifyClient()

type UserInvits = {
  organizationMemberbyUser: {
    items: OrganizationMember[]
  }
}

export const useUserInvits = ({ userID }) => {
  return useQuery({
    queryKey: ['notifications', userID],
    queryFn: async () => await listUserInvits(userID),
    staleTime: 1000 * 60 * 2,
    enabled: !!userID,
    placeholderData: [],
  })
}

const listUserInvits = async (userID) => {
  try {
    const { data: organizations } = (await client.graphql({
      query: listUserInvitsQuery,
      variables: {
        userID,
        status: { eq: 'PENDING' },
        filter: { type: { ne: 'PROJECT' } },
      },
    })) as GraphQLResult<UserInvits>

    const itemsOrgs = organizations?.organizationMemberbyUser.items || []

    const { data: projetcs } = (await client.graphql({
      query: listUserInvitsQuery,
      variables: {
        userID,
        status: { eq: 'DONE' },
        filter: {
          type: { eq: 'PROJECT' },
          seen: { ne: true },
        },
      },
    })) as GraphQLResult<UserInvits>

    const itemsProjects = projetcs?.organizationMemberbyUser.items || []

    return [...itemsOrgs, ...itemsProjects].map(notificationAdapter)
  } catch (e) {
    console.error(e)
    throw e
  }
}
